import rootStore from "@/app/store";
import crud, { ApiResponse } from "../crud";

export interface Device {
  id: number;
  device_id: string;
  location_id: number;
  owner_id: number;
  name: string;
  floor: number;
}

export function DevicesAPI(baseUrl: string) {
  return {
    list: async () => {
      const renterId = rootStore.getState().location.location.id;
      return (await crud.get(
        `${baseUrl}/devices?renter_id=${renterId}`,
        undefined,
        true,
      )) as ApiResponse<Device[]>;
    },
  };
}
